/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".graph-rows[_ngcontent-%COMP%]{margin-left:-15px;margin-right:-15px}"];
export { styles as styles };
